require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-hugo-guerra.json") })
        }
      }, "path---blog-author-hugo-guerra");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-hugo-guerra!./.cache/json/blog-author-hugo-guerra.json
// module id = 641
// module chunks = 231608221292675